import { WriskTheme } from '@wrisk/ui-components'
import { useMemo } from 'react'
import { useTheme } from 'styled-components'

import {
  StripeCheckoutRequest,
  StripeMotoCheckoutRequest,
} from '../clients/api/clients/paymentCard'
import { TKey, useWriskTranslation } from '../infrastructure/internationalisation'
import { pathWithOrigin } from '../util/dom'

const tKey = TKey('components.pay-now')

export type StripeCheckoutRequestParams = {
  cancelPath: string
  successPath: string
  saveCard: boolean
}

export const useStripeCheckoutRequest = ({
  cancelPath,
  successPath,
  saveCard,
}: StripeCheckoutRequestParams): StripeCheckoutRequest => {
  const { t, i18n } = useWriskTranslation()
  const theme = useTheme() as WriskTheme

  return useMemo(
    () => ({
      cancelUrl: pathWithOrigin(cancelPath),
      successUrl: pathWithOrigin(successPath),
      lineItem: {
        description: t<string>(tKey('line-item.description')),
        name: t(tKey('line-item.name')),
        imageUrl: theme.illus.lineItem ? pathWithOrigin(theme.illus.lineItem) : undefined,
      },
      locale: i18n.language,
      saveCard,
    }),
    [theme, t, i18n],
  )
}

type StripeMotoCheckoutRequestParams = {
  saveCard: boolean
}

export const useMotoCheckoutRequest = ({
  saveCard,
}: StripeMotoCheckoutRequestParams): Pick<
  StripeMotoCheckoutRequest,
  'country' | 'itemName' | 'saveCard'
> => {
  const { t, i18n } = useWriskTranslation()

  return useMemo(
    () => ({
      country: new Intl.Locale(i18n.language).region ?? i18n.language,
      itemName: t(tKey('line-item.name')),
      saveCard,
    }),
    [t, i18n],
  )
}
